export const ARTICLES = 'articles'
export const ARTICLE_STATUS = ['draft', 'published', 'hide']
